{
  "title": "如何填寫報名表單",
  "description": "在報名開放期間依競賽要求填寫報名資料，表單會自動儲存，截止前可隨時回來修改。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您的報名資料會被儲存並視為已送出；報名表單沒有像作品提交一樣的鎖定機制，在報名截止前可隨時修改。",
  "roleNote": "參賽者",
  "prerequisites": ["已加入或建立隊伍", "該場競賽的報名時程尚未結束"],
  "pathLabel": "競賽詳情頁 → 報名資料",
  "steps": [
    {
      "title": "1. 開啟報名資料區塊",
      "description": "在競賽詳情頁的「報名資料」區塊，依主辦方設定的欄位填寫；欄位是否必填由主辦方設定，可能隨版本更新而調整。必填欄位標有紅色星號。有些欄位只在特定選項下才會出現（例如選擇「參賽組別」後，才會出現該組別的欄位）；切換選項時，不再適用的欄位會被隱藏，先前為它填的答案也會被清除，需要重新填寫。"
    },
    {
      "title": "2. 自動儲存與手動儲存",
      "description": "表單會在您填寫時自動儲存，成功時畫面顯示「已自動儲存」與時間；但系統只在所有必填欄位都已填妥且通過驗證時才會儲存，若還有必填欄位未完成，畫面會提示「尚有必填欄位未完成，填寫完成後會自動儲存」，此時尚未存入任何內容。必填的勾選框（例如「團隊聲明」）必須勾選才算填妥。您也可以自行按下畫面上的「確認並完成報名」（已完成過的報名則顯示為「儲存變更」）儲存。"
    },
    {
      "title": "3. 確認完成",
      "description": "所有必填欄位皆已通過驗證並儲存成功後，報名資料即視為已送出；第一次完成時，畫面會顯示完成狀態。"
    }
  ],
  "afterward": [
    "畫面顯示已儲存的報名資料摘要",
    "報名截止前可隨時點擊「查看／修改報名資料」重新開啟表單修改，此時按鈕會變成「儲存變更」",
    "修改後可重新儲存，沒有版本鎖定機制",
    "報名截止後無法再儲存或修改，畫面會顯示「報名時間已截止」；截止時間以競賽頁顯示的日期為準（目前輪次的報名截止時間）",
    "若主辦方之後修改了報名表單，或您已儲存的答案不符合目前表單（例如必填的勾選框沒有勾選），報名資料會顯示「需補填」，請見常見問題"
  ],
  "nextSteps": "接著可以前往作品繳交表單，開始準備要提交的作品。",
  "faq": [
    {
      "q": "填完報名表單就等於完成報名了嗎？",
      "a": "是的，報名表單沒有另外的「正式提交」步驟，儲存成功即完成報名；這與作品繳交需要額外「正式提交」不同。"
    },
    {
      "q": "儲存時顯示缺少必填欄位怎麼辦？",
      "a": "畫面會標示出哪個欄位未填寫或格式不符，請依提示補齊後再重新儲存。必填的勾選框（例如「團隊聲明」）沒有勾選也會被視為缺漏。"
    },
    {
      "q": "報名表單儲存會被學生資格驗證擋下嗎？",
      "a": "不會。即使該場競賽開啟「學生資格驗證」政策，也不會擋下報名表單的儲存或完成報名；兩者互相獨立。資格驗證狀態會另外顯示在「參賽資訊」摘要區塊的完成度磚，並在獨立的「學生資格驗證」頁面上傳在學證明、追蹤審核進度。"
    },
    {
      "q": "看到「報名資料需補填」怎麼辦？",
      "a": "表示您已儲存的答案不符合目前表單的必填規則，例如新增了必填欄位，或必填的「團隊聲明」沒有勾選。請在競賽頁的「報名資料」卡片點擊「補填報名資料」，補上缺少的欄位後按「儲存變更」，並請在報名截止前完成。系統不會替您勾選任何聲明，也不會取消您的報名。"
    },
    {
      "q": "填到一半重新整理頁面，已填的內容會不見嗎？",
      "a": "只有在所有必填欄位都已填妥、自動儲存成功之後，內容才會被保存；若還有必填欄位沒填，尚未存入任何內容，重新整理後需要重新填寫。"
    }
  ]
}
